import React from 'react';
import PropTypes from 'prop-types';
import { auth } from '../../utils/auth';
import { css } from 'react-emotion';
import FulfillerLogo from 'react-cimpress-fulfiller-logo';
import { typeIsFulfiller, typeIsMerchant } from '../../reducers/identities/utils';

const logoStyle = css`
  max-width: 30px;
  max-height: 30px;
  display: inline-block;
`;

const IdentityBadge = ({ identityType, identityId, identityName }) => {
  if (typeIsFulfiller(identityType)) {
    return (
      <div className="identity-badge">
        <FulfillerLogo className={logoStyle} fulfillerId={identityId} accessToken={auth.getAccessToken()} />
        {`${identityName} (fulfiller)`}
      </div>
    );
  } else if (typeIsMerchant(identityType)) {
    return <div className="identity-badge">{`${identityName} (merchant)`}</div>;
  } else {
    return <div className="identity-badge">{`${identityName}`}</div>;
  }
};

IdentityBadge.propTypes = {
  identityType: PropTypes.string,
  identityId: PropTypes.string,
  identityName: PropTypes.string
};

export default IdentityBadge;
